<template>
  <!-- Dialog for ERROR - results -->
  <v-dialog max-width="600px" v-model="displayError">
    <v-card class="d-block">
      <v-card-title
        class="pt-7 secondary--text font-weight-bold text-center d-block"
        style="font-size: 30pt;"
      >There was an error.</v-card-title>
      <v-card-text class="headline mt-7 text-center">
        <p>We could not complete your request. The details of the error follow below.</p>
      </v-card-text>
      <v-card-text>
        This was the error from the server:
        <code
          class="d-block white--text error"
        >{{internal_error}}</code>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="primary" text @click="internal_error = null">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- DIALOG ERROR END -->
</template>
<script>
export default {
	name: "ErrorDialog",
	props: {
		error: null
	},
	data() {
		return {
			internal_error: !!this.error
		}
	},
	computed: {
		displayError() {
			return !!this.internal_error
		}
	},
	watch: {
		error: function(newError) {
			this.internal_error = newError
		}
	}
}
</script>